import bg1 from "../images/sankranti/sankranti_bg1.png";
import bg2 from "../images/sankranti/sankranti_bg2.png";

export const sankrantislides = [

/* ---------------- 🪁 SLIDE 1 — FESTIVAL INTRO ---------------- */
[
  {
    id: 1,
    type: "background",
    src: bg1,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  {
    id: 2,
    type: "text",
    text: "🌾 शुभ संक्रांति 🌾",
    x: 50,
    y: 100,
    fontSize: 30,
    fontFamily: "Poppins",
    fill: "#092202",
  },

  {
    id: 3,
    type: "text",
    text: "Sankranti Celebrations 2026",
    x: 30,
    y: 150,
    fontSize: 24,
    fontFamily: "Poppins",
    fill: "#092202"
  },

  {
    id: 4,
    type: "text",
    text: "🌾Celebrate Harvest, Happiness & Traditions🌾",
    x: 20,
    y: 200,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#092202"
  },

  {
    id: 5,
    type: "text",
    text: "Join us for a joyful celebration filled with colors, kites & culture",
    x: 15,
    y: 300,
    fontSize: 14,
    fontFamily: "Poppins",
    fill: "#092202"
  },

  {
    id: 6,
    type: "text",
    text: "🪁 Kite Flying ",
    x: 60,
    y: 400,
    fontSize: 30,
    fontFamily: "Poppins",
    fill: "#111827"
  },
  {
    id: 17,
    type: "text",
    text: "🌸 Rangoli ",
    x: 80,
    y: 450,
    fontSize: 30,
    fontFamily: "Poppins",
    fill: "#111827"
  },
  {
    id: 18,
    type: "text",
    text: "🔥 Bhogi Mantalu",
    x: 40,
    y: 500,
    fontSize: 30,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 7,
    type: "text",
    text: "🍚 Traditional Food",
    x: 30,
    y: 550,
    fontSize: 30,
    fontFamily: "Poppins",
    fill: "#111827"
  },
  {
    id: 19,
    type: "text",
    text: "🐂 Cultural Events",
    x: 50,
    y: 600,
    fontSize: 30,
    fontFamily: "Poppins",
    fill: "#111827"
  }
],


/* ---------------- 🪁 SLIDE 2 — INVITATION DETAILS ---------------- */
[
  {
    id: 8,
    type: "background",
    src: bg2,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  

  {
    id: 10,
    type: "text",
    text: "🌞 You're Invited 🌞",
    x: 280,
    y: 90,
    fontSize: 28,
    fontFamily: "Open Sans",
    fill: "#520c1b"
  },

  {
    id: 11,
    type: "text",
    text: "📅 14 January 2026",
    x: 300,
    y: 150,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 12,
    type: "text",
    text: "⏰ 8:00 AM onwards",
    x: 280,
    y: 200,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 13,
    type: "text",
    text: "📍 Open Grounds, Vijayawada",
    x: 250,
    y: 250,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#111827"
  },

  {
    id: 14,
    type: "text",
    text: "🎉Let's Celebrate Together🎉",
    x: 260,
    y: 480,
    fontSize: 26,
    fontFamily: "Open Sans",
    fill: "#520505"
  },

  {
    id: 15,
    type: "text",
    text: "Wishing You Joy,",
    x:310,
    y: 530,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#374151"
  },
  {
    id: 20,
    type: "text",
    text: "Prosperity & Happiness",
    x: 290,
    y: 580,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#374151"
  },

  {
    id: 16,
    type: "text",
    text: "🌾 Happy Sankranti 🌾",
    x: 280,
    y: 650,
    fontSize: 28,
    fontFamily: "Dancing Script",
    fill: "#000"
  }
]

];